// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import electrowireColors from "@electrowire/XDL/PreStyle/colors";
import gcgColors from "@gcg/XDL/PreStyle/colors";
import seacoastusaColors from "@seacoastusa/XDL/PreStyle/colors";

const getPreStyleColors = () => {
    if (BLUEPRINT_NAME === "electrowire") {
        return electrowireColors;
    }
    if (BLUEPRINT_NAME === "seacoastusa") {
        return seacoastusaColors;
    }
    return gcgColors;
};

export default getPreStyleColors;
